module.exports = __webpack_public_path__ + "static/media/22.221aa073.jpg";